import { render, staticRenderFns } from "./ModelTypesView.vue?vue&type=template&id=88aed45c&scoped=true"
import script from "./ModelTypesView.vue?vue&type=script&lang=js"
export * from "./ModelTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aed45c",
  null
  
)

export default component.exports